export enum DemandsClassroomsEnum {
    ClassroomsExisting = 1,
    ClassroomRequired = 2,
    ClassroomDemand = 3
}
